module.exports = __webpack_public_path__ + "img/Premium-Notebook.cfec1a1.png";